/**
 * ============================================================================
 * GRATIA - assets/article-toc.js
 * ----------------------------------------------------------------------------
 * <article-toc> builds a table of contents from the article's h2/h3, adds
 * anchor ids, smooth-scrolls, and highlights the section in view. If the
 * article has no headings, the TOC removes itself.
 * ============================================================================
 */
(function () {
  'use strict';
  class ArticleToc extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-toc-list]');
      const content = document.querySelector('[data-article-content]');
      if (!this.list || !content) { this.remove(); return; }
      const headings = content.querySelectorAll('h2, h3');
      if (headings.length < 2) { this.closest('aside')?.remove(); return; }

      this.links = [];
      headings.forEach((h, i) => {
        if (!h.id) h.id = `section-${i}-${(h.textContent || '').toLowerCase().replace(/[^\w]+/g, '-').slice(0, 40)}`;
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${h.id}`;
        a.textContent = h.textContent;
        a.className =
          '-ml-px block border-l-2 border-transparent pl-3 text-sm text-muted transition-colors hover:text-primary' +
          (h.tagName === 'H3' ? ' pl-6' : '');
        a.addEventListener('click', (e) => {
          e.preventDefault();
          h.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', `#${h.id}`);
        });
        li.appendChild(a);
        this.list.appendChild(li);
        this.links.push({ a, h });
      });

      this.observe(headings);
    }

    observe(headings) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.links.forEach(({ a, h }) => {
              const active = h === entry.target;
              a.classList.toggle('border-primary', active);
              a.classList.toggle('text-primary', active);
              a.classList.toggle('text-muted', !active);
            });
          });
        },
        { rootMargin: '-10% 0px -70% 0px' }
      );
      headings.forEach((h) => io.observe(h));
    }
  }
  if (!customElements.get('article-toc')) customElements.define('article-toc', ArticleToc);
})();
